import styled, { css } from 'styled-components';

import {
  Card,
  GridContent,
  GridLayout,
  mediaMixin,
  PageBreadcrumb,
  PageContent,
  TextButton,
  token,
} from '@zillow/constellation';

import BackgroundImage from '../../../images/rentalProtection/choose_coverage_level_bg_desktop.svg';
import BackgroundImageMweb from '../../../images/rentalProtection/choose_coverage_level_bg_mobile.svg';

export const StyledPageContent = styled(PageContent)`
  padding-right: 0;
  padding-left: 0;
`;

export const StyledPageBreadcrumb = styled(PageBreadcrumb)`
  background-color: ${token('colors.backgroundWhite')};
  ${mediaMixin(
    'md_lte',
    css`
      background-color: ${token('colors.backgroundBlue')};
      margin: 0;
      padding-top: 24px;
      padding-bottom: 24px;
    `,
  )}
`;

export const StyledCoverageOptionsContainer = styled(GridLayout)`
  max-width: 450px;
  border: 1px solid ${token('colors.borderLight')};
  border-radius: 4px;
  cursor: pointer;
`;

export const StyledTextButton = styled(TextButton)`
  font-size: ${token('fontSizes.bodySmall')}px;
`;

export const StyledBannerImageDiv = styled.div`
  margin: auto;

  background-image: url(${BackgroundImage});
  width: 520px;
  height: 626px;

  ${mediaMixin(
    'md_lte',
    css`
      background-image: url(${BackgroundImageMweb});
      width: auto;
      height: 239px;
    `,
  )}
`;

export const StyledCard = styled(Card)`
  position: absolute;
  max-width: 450px;
  margin-left: -25px;
`;

export const StyledImageGridContainer = styled(GridContent)`
  margin-right: auto;
  margin-left: auto;
`;
